import { isMobileApp } from './descopeQueryParams';

const injected = new Set<string>();

/**
 * Inject a `<link rel="prefetch" as="document">` for a same-origin next-hop
 * page so the browser fetches the HTML during idle time, collapsing the next
 * navigation's TTFB to "edge POP RTT" instead of "full handshake + document
 * fetch" (MONEY-792).
 *
 * @param path Absolute path on the current origin (e.g. `/admin`,
 *             `/register/get-started`). Resolved by the browser against the
 *             document's origin, so it works across prod/qa/local without
 *             configuration.
 *
 * Idempotent per-path across the session. No-op inside native mobile
 * WebViews, which handle post-auth navigation natively and never visit
 * the prefetched URL.
 */
export function prefetchNextHop(path: string): void {
  if (typeof document === 'undefined') {
    return;
  }
  if (isMobileApp()) {
    return;
  }

  if (injected.has(path)) {
    return;
  }

  if (document.head.querySelector(`link[rel="prefetch"][href="${path}"]`)) {
    injected.add(path);
    return;
  }

  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = path;
  link.setAttribute('as', 'document');
  document.head.appendChild(link);
  injected.add(path);
}
